// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Preloader_loaderContainer__197Yv","overlay":"Preloader_overlay__-bBfJ"};